import { useFilterByPrimaryDimensionDeviceId } from '../utils';
import { usePersonDeviceFieldApi } from './api';

export const usePersonDevicesCountry = () => {
  const filterPredicate = useFilterByPrimaryDimensionDeviceId();
  const result = usePersonDeviceFieldApi({
    filterPredicate,
    field: 'country',
  });
  return result;
};
